import PropTypes from "prop-types";
import RichTextComponent from "../RichTextComponent";

const TypographyLibreBaskerville = ({ text, children, className }) => {
    const typography = children ? (
        <RichTextComponent
            text={children}
            className={`font-['Libre_Baskerville'] text-Primary_Default ${className}`}
        />
    ) : (
        <p
            className={`font-['Libre_Baskerville'] text-Primary_Default ${className}`}
        >
            {text}
        </p>
    );

    return typography;
};
TypographyLibreBaskerville.propTypes = {
    text: PropTypes.string,
    children: PropTypes.array,
};

export default TypographyLibreBaskerville;
